<template>
     <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>假期管理->员工假期余额</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.name" placeholder="姓名"></el-input>
                    </div>
                </div>
 
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div> 
            </div>
            <el-table
                :data="data"
                style="width:100%;margin-bottom:20px;"
                row-key="id"
                height="550"
                border
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                default-expand-all>
                <el-table-column type="index" :index="indexMethod" label="序号" width="50px"></el-table-column>
                <el-table-column prop="name" label="姓名" :show-overflow-tooltip="true" width="100px"></el-table-column>
                <el-table-column prop="deptName" label="部门" :show-overflow-tooltip="true" width="100px"></el-table-column>
                <el-table-column v-for="item in headerList" :key="item.ruleId" :prop="item.ruleId"  :label="item.vacationName" width="150px">
                    <template slot-scope="scope">
                        <div v-if="scope.row[scope.column.property] ==undefined || !scope.row[scope.column.property+'_switch']">
                            {{generateColumn(scope.row[scope.column.property])}}
                        </div>
                        <el-button  v-else
                            @click.native.prevent="setUpdate(scope.row[scope.column.property])"
                            type="text">
                            <span style="color: #387EE8;">{{generateColumn(scope.row[scope.column.property])}}</span> 
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 更改余额弹出框 -->
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import update from './Update.vue'; 

    export default {
        name:"VacationSurplus",
        data(){
            return{
                loading:false,
                updateVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                data:[], // 表格数据
                headerList: [], // 表头数据
                depts:[],
                form:{
                    deptId:"",
                    name:""
                },
            }
        },
        components: {
           update
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.staffVacationSurplusListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    schoolId:this.form.deptId,
                    name:this.form.name
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data.dataList));
                    if(res.status == 200){
                        this.data = res.data.dataList;
                        this.headerList = res.data.headerList; 
                        this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            setUpdate(val){
                if(val == undefined){
                    return;
                }
                let valArr=val.split(':');
                if(valArr[1] != 'true'){
                    return;
                }
                
                // console.log(valArr[2]);
                let url  = this.staffVacationSurplusGetUrl;
                let data = {
                    id:valArr[0]
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data));
                    // return;
                    if(res.status == 200){
                        this.updateVisible=true;
                        this.$nextTick(() => {
                            this.$refs['update'].init(res.data);
                        })
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });

                

            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            // 构造列显示值
            generateColumn(val){
                if(val == undefined){
                    return "不适用"
                }
                let valArr=val.split(':');
                if(valArr[1] == 'true'){
                    return valArr[2];
                }else{
                    return "不限制余额";
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped> 

</style>



// WEBPACK FOOTER //
// src/components/page/vacation/vacationSurplus/List.vue